import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';
import {entities} from '../../../../../../../util/uiconstants';
import {
	getControlsSlice,
	getITProcessById,
	getBodyMetadataSlice
} from '../../../../../../../selectors/ISA315/selectors';
import {applyFilters} from './clientFilters.utils';
import {getItProcessControlCount} from './commonCounters';
import BodySpecialAccordionHeaderColumn from '../BodySpecialAccordionHeaderColumn';

function ItProcessControlCount({itProcessId, bodyId, header, className, hasControlTesting, controlTypeId}) {
	const itProcess = useSelector((state) => getITProcessById(state, itProcessId)),
		allControls = useSelector(getControlsSlice),
		bodyMetadata = useSelector((state) => getBodyMetadataSlice(state, bodyId));

	const distinctControlIds = [...new Set(itProcess.controls)];

	// Apply configured filters for the current body
	const filteredControlIds = applyFilters(
		entities.Control,
		bodyMetadata.clientFilters,
		distinctControlIds,
		allControls.byId
	);

	const controlsCount = getItProcessControlCount(
		itProcess,
		allControls,
		filteredControlIds,
		hasControlTesting,
		controlTypeId
	);

	return <StyledItProcessControlCount className={className} header={header} value={controlsCount || '-'} />;
}

ItProcessControlCount.propTypes = {
	itProcessId: PropTypes.number.isRequired,
	bodyId: PropTypes.number,
	header: PropTypes.string.isRequired,
	className: PropTypes.string,
	hasTesting: PropTypes.bool,
	controlTypeId: PropTypes.number.isRequired
};

export default ItProcessControlCount;

const StyledItProcessControlCount = styled(BodySpecialAccordionHeaderColumn)`
	width: var(--px-100);
`;
